<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <v-img
          src="../../public/static/Easel Top.png"
          :width="easelTop"
          eager
        />
        <v-img
          src="https://streetcar-east.s3.us-east-2.amazonaws.com/Welcome%2BPage_Streetcar%2BVMR.png"
          eager
          width="95%"
        />
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        />
      </v-col>
      <v-col
        align="center"
        justify="center"
        :cols="columns"
        style="max-height:85vh; overflow-y:auto"
      >
        <v-card class="slide-card" style="max-width: 90%;">
          <div class="slide-content">
            <p><strong>Welcome</strong></p>
            <p>
              Thank you for visiting the Streetcar East Extension project
              website. The information on this site reflects the ongoing
              preliminary engineering activities and provides an opportunity for
              public comment.
            </p>

            <p>
              A recording of the public meetings on May 27, 2021, and September
              13, 2022, are available on the Public Comment page and can also be
              found on MARTA’s YouTube page.
            </p>
            <p>
              <strong
                >Here are some helpful tips to navigate the virtual
                site:</strong
              >
            </p>
            <ul>
              <li>
                <p>
                  The following browsers are recommended for the site: Chrome,
                  Firefox, Safari, or Edge.
                </p>
              </li>
              <li>
                <p>
                  Click the left or right arrow on each side of your screen or
                  select your station of choice from the navigation bar below.
                </p>
              </li>
              <li>
                <p>
                  This website is interactive. Click on the displays and buttons
                  for additional information in each station.
                </p>
              </li>
              <li>
                <p>
                  To request this information in another language or in an
                  accessible format, call 404-848-4037 or 404-848-5665 (TTY).
                </p>
              </li>
            </ul>
          </div>
          <!-- <BigButton
            text="Take Our Survey"
            url="https://marta-streetcar.dh8qz31pqmn6d.amplifyapp.com/MartaStreetcar/StreetcarEastProject/MartaStreetcarMeeting1"
          /> -->
          <br />
          <br />
        </v-card>
      </v-col>
    </v-row>

    
    
    <!-- <v-dialog
      v-model="showDialog"
      width="75%"
      height="50%"
      style="min-height: 55% !important;"
    >
      <v-card>
        <v-app-bar dark color="primary" >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <p>
                Learn more about the recent Irwin Street Traffic Study and TAKE THE SURVEY to provide your feedback! Visit the Irwin Street Traffic Study tab to learn more.
              </p>
              <v-row
                justify="center"
                style="padding-top: 3%;padding-bottom: 5%;"
              >
                <v-btn
                  color="primary"
                  dark
                  class="buttons"
                  href="https://arcg.is/19Tijz1"
                  target="_blank"
                >
                  TAKE SURVEY
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog> -->
  </v-sheet>
</template>

<script>
// import MeetingReminderModal from "./MeetingReminderModal.vue";
// import BigButton from "@/components/BigButton.vue";
// import HelpText from "@/components/HelpText.vue";
export default {
  name: "Welcome",
  components: {
    // MeetingReminderModal
    // BigButton
  },
  data: () => ({
    showMeetingDialog: true,
    showSignUp: false,
    showDialog: true,
    showHelpText: false,
    showEventSignUp: false,
    eventType: "",
    aboutText: `<p>Learn more about the recent Irwin Street Traffic Study and
TAKE THE SURVEY to provide your feedback!
Visit the Irwin Street Traffic Study tab to learn more.</p>

              <v-row
                justify="center"
                style="padding-top: 3%;padding-bottom: 5%;"
              >
                <v-btn
                  color="primary"
                  dark
                  class="buttons"
                  href="https://arcg.is/19Tijz1"
                  >TAKE SURVEY</v-btn
                >
              </v-row>
`,
    helpText1: `<p>MARTA will host <strong><u>two</u></strong> public meetings for the
Streetcar East Extension project to provide an update on the ongoing
planning and preliminary engineering activities. MARTA will have a
virtual and in-person meeting option. We encourage you to attend one of
the following:</p>
<p>In-person Meeting: Monday, September 12, 2022, at 6:00 p.m. (Face
masks are required by the venue)</p>
<ul>
<li><p>Location: Dad’s Garage</p></li>
<li><p>Address: 569 Ezzard St SE, Atlanta, GA 30312</p>
<p>This venue is a short walk from the BeltLine Eastside Trail, MARTA Bus Route #809, and the Atlanta Streetcar’s King Historic District station. Parking is available in the lot across the street. </p></li>
</ul></li>
</ul>
`,

    helpText2: `<p>Virtual Meeting (Zoom): Tuesday, September 13, 2022, at 6:00
p.m.</p>
<ul>
<li><p>Please register to receive the Zoom information via
email.</p></li>
</ul>`,
    helpText3: `<p>If you are unable to attend, this project website will be updated
following the meetings.</p>`
  }),
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleHelpText() {
      this.showMeetingDialog = !this.showMeetingDialog;
      this.showReminderModal = false;
    },
    setInPerson() {
      this.eventType = "In Person";
      this.showEventSignUp = !this.showEventSignUp;
    },
    setVirtual() {
      this.eventType = "Virtual";
      this.showEventSignUp = !this.showEventSignUp;
    },
    closeForm() {
      console.log("closing form");
      this.showEventSignUp = false;
    },
    toggleModal() {
      this.showDialog = !this.showDialog;
    }
  }
};
</script>

<style scoped>
.slide-content {
  text-align: justify;
  font-family: sans-serif;
  /* font-size: 1rem; */
  font-size: 16px;
}
.v-toolbar {
  background-color: rgb(0, 140, 204) !important;
}

.buttons {
  color: white !important;
}

.meeting-info {
  width: 85%;
  line-height: 1.2;
  border-style: groove;
  border-color: #2b81d6;
  padding: 10px;
  border-radius: 10px;
  background-color: white;
}
</style>
